import { render, staticRenderFns } from "./VineyardsModuleComponent.vue?vue&type=template&id=1550ef09&scoped=true&"
import script from "./VineyardsModuleComponent.vue?vue&type=script&lang=js&"
export * from "./VineyardsModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./VineyardsModuleComponent.vue?vue&type=style&index=0&id=1550ef09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1550ef09",
  null
  
)

export default component.exports